import { render, staticRenderFns } from "./KCWalletPassAdmin.vue?vue&type=template&id=719a3366&scoped=true&"
import script from "./KCWalletPassAdmin.vue?vue&type=script&lang=js&"
export * from "./KCWalletPassAdmin.vue?vue&type=script&lang=js&"
import style0 from "./KCWalletPassAdmin.vue?vue&type=style&index=0&id=719a3366&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719a3366",
  null
  
)

export default component.exports